export const wordify = (die) => {
  if(die.value === 1) {
    return 'one';
  }
  if(die.value === 2) {
    return 'two';
  }
  if(die.value === 3) {
    return 'three';
  }
  if(die.value === 4) {
    return 'four';
  }
  if(die.value === 5) {
    return 'five';
  }
  if(die.value === 6) {
    return 'six';
  }
}
